import { useAtom } from "jotai";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { OutsideLayout } from "../../../components/layout/OutsideLayout";
import { TuvNordLogo } from "../../../components/shared/TuvNordLogo";
import { authAtom } from "../auth.atom";
import { login, LoginType } from "../auth.service";
import { LoginForm } from "../components/LoginForm";

export const Login = () => {
    const [auth, setAuth] = useAtom(authAtom);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (auth?.id) {
            navigate("/");
        }
    }, [auth?.id, navigate]);

    const handleLogin = (data: LoginType) =>
        login(data).then((response) => {
            setAuth(response);
            navigate(location.state?.originUrl || "/");
        });

    return (
        <OutsideLayout>
            <div className="text-center">
                <TuvNordLogo className="inline-block mb-8" />
                <p className="mb-4 text-lg">Login to your Account</p>
            </div>
            <LoginForm onSubmit={handleLogin} />
        </OutsideLayout>
    );
};
